<div class="layout-sidebar" [class.is-compact]="isCompactMode()" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div
    class="sidebar-gap-zone"
    *ngIf="!layoutService.isMobile()"
    (mouseenter)="onGapMouseEnter()"
    (mouseleave)="onGapMouseLeave()"
  >
    <button
      type="button"
      class="sidebar-gap-toggle"
      [class.is-hovering]="hoverGapToggle"
      [attr.aria-label]="isCompactMode() ? 'Sidebar ausklappen' : 'Sidebar einklappen'"
      (click)="changeMenuLayout()"
    >
      <!-- Clip-Fenster: beginnt an der Sidebar-Kante, schneidet links ab —
           der Griff federt dahinter hervor (DS Sidebar.jsx GapToggle) -->
      <span class="sidebar-gap-toggle__clip">
        <span class="sidebar-gap-toggle__handle" [class.is-compact]="isCompactMode()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M9 2 L4 7 L9 12" stroke="currentColor" stroke-width="1.5"
              stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
      </span>
    </button>
  </div>

  <div class="sidebar-header pt-5 flex flex-col items-center">
    <img
      alt="necta.one Logo"
      class="sidebar-logo mb-3.5"
      src="../../../assets/img/necta_logo_white.svg"
      (click)="navigateWelcomeDashboard()"
    />
    <button class="layout-sidebar-anchor z-2" type="button" (click)="anchor()"></button>
  </div>

  <div #menuContainer class="layout-menu-container flex flex-col h-full min-h-0">
   
    

    
    <div
      class="menu-gap-zone"
      (mouseenter)="onGapMouseEnter()"
      (mouseleave)="onGapMouseLeave()"
    ></div>

    @if(userStore.isRegisteredNectaOne() === true) {
      <app-active-tenant-menu class="mb-3 menu-layer"></app-active-tenant-menu>
    } 
    
    <app-main-menu class="menu-layer"></app-main-menu>
    <app-user-menu class="mt-auto menu-layer"></app-user-menu>
  </div>

  <div app-topbar *ngIf="isHorizontal() && !layoutService.isMobile()"></div>
</div>